export default __webpack_public_path__ + "static/media/9d28a68b-4835-466b-81cc-68c579f043ce.2385ff9c.woff2";